// // src/pages/treatments/HipReplacementPage.jsx
// import React from "react";
// import TreatmentTemplate from "./TreatmentTemplate";
// import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

// const HIP_REPLACEMENT_TREATMENT = {
//   slug: "hip-replacement",
//   name: "Hip Replacement Surgery",
//   shortName: "Hip Replacement",
//   tagline: "Move Freely Again. Precision Surgery. Lasting Relief.",
//   heroSubtag:
//     "Advanced hip replacement surgery at a fraction of Western costs. India's top orthopaedic surgeons. Outstanding functional outcomes.",
//   description:
//     "Comprehensive hip replacement care covering total hip replacement, partial (hemiarthroplasty) hip replacement, robotic-assisted surgery, minimally invasive anterior approach and revision hip replacement — supported by advanced physiotherapy, pain management and lifelong post-operative follow-up. Our multidisciplinary orthopaedic teams review every case to deliver globally benchmarked, personalised treatment plans with exceptional outcomes.",
//   heroImage: "/HipReplacement.jpeg",
//   category: "Orthopedics",
//   badge: "Advanced Joint Care",
//   accentColor: "blue",
//   costCard: {
//     label: "Hip replacement packages",
//     value: "₹2.5L–₹5L",
//     compare: "vs. £15,000–£25,000 in the UK",
//     stay: "Typically 10–14 days in India post-surgery",
//     stayCompare: "vs. $30,000–$60,000 in the USA",
//   },
//   stats: [
//     { label: "Success Rate", value: "97%+", icon: Award },
//     { label: "Surgeries Performed", value: "25,000+", icon: Users },
//     { label: "Years Experience", value: "25+", icon: Shield },
//     { label: "Hospital Stay", value: "4–6 Days", icon: Clock },
//   ],
//   benefits: [
//     "Robotic-assisted total hip replacement for millimetre-precise implant positioning",
//     "Minimally invasive anterior approach — no muscle cutting, faster recovery",
//     "Patient-specific implants manufactured from pre-operative CT scan data",
//     "Ceramic, titanium and highly cross-linked polyethylene bearing options",
//     "Bilateral (both hips) simultaneous replacement where clinically appropriate",
//     "Revision hip replacement for failed previous implants or dislocations",
//     "Accelerated rehabilitation protocol — walking within 6 hours of surgery",
//     "Comprehensive pain management — multimodal anaesthesia, nerve blocks, epidural",
//   ],
//   procedure: [
//     {
//       step: "01",
//       title: "Assessment & Planning",
//       desc: "Full orthopaedic evaluation — weight-bearing X-rays, MRI, leg length analysis, deformity assessment and 3D implant pre-operative planning.",
//       duration: "2–3 Days",
//       icon: Calendar,
//     },
//     {
//       step: "02",
//       title: "Pre-Operative Optimisation",
//       desc: "Cardiac and anaesthesia clearance, physiotherapy assessment, blood optimisation, DVT risk stratification and patient education on recovery.",
//       duration: "1–2 Days",
//       icon: Activity,
//     },
//     {
//       step: "03",
//       title: "Hip Replacement Surgery",
//       desc: "Robotic-assisted or conventional total hip replacement via anterior or posterior approach under spinal or general anaesthesia by senior orthopaedic surgeon.",
//       duration: "1.5–2.5 Hours",
//       icon: ThumbsUp,
//     },
//     {
//       step: "04",
//       title: "Rehabilitation & Discharge",
//       desc: "Physiotherapy begins 6 hours post-surgery. Walking with frame by day 1. Stair climbing by day 3. Discharge at day 4–6 with home exercise and follow-up protocol.",
//       duration: "4–6 Days",
//       icon: Heart,
//     },
//   ],
//   faqs: [
//     {
//       q: "Who needs hip replacement surgery?",
//       a: "Hip replacement is recommended for patients with severe hip arthritis (osteoarthritis, rheumatoid arthritis, avascular necrosis or post-traumatic arthritis) causing persistent pain, stiffness, limping and loss of function that has not responded adequately to conservative treatments such as physiotherapy, injections and anti-inflammatory medications.",
//     },
//     {
//       q: "What is the anterior approach to hip replacement?",
//       a: "The anterior (front) approach accesses the hip joint without cutting through any major muscles — unlike the traditional posterior approach. This results in less post-operative pain, a lower dislocation risk, faster return to walking and a shorter rehabilitation period. Not all patients are candidates; your surgeon will advise based on your anatomy and BMI.",
//     },
//     {
//       q: "What is robotic-assisted hip replacement?",
//       a: "Robotic-assisted hip replacement uses a CT-based 3D model of your hip to plan the exact position, angle and depth of your implant before surgery. During the procedure, the robotic arm guides the surgeon to execute implant placement within 1mm of the pre-operative plan — resulting in better leg length restoration, reduced dislocation risk and faster recovery.",
//     },
//     {
//       q: "How long does a hip replacement last?",
//       a: "Modern hip implants last 20–30 years in the majority of patients. Ceramic-on-ceramic and ceramic-on-polyethylene bearing combinations offer the lowest wear rates. Longevity depends on activity level, weight, implant type and surgical technique. Robotic-assisted surgery improves component positioning, one of the most important factors for long-term survival.",
//     },
//     {
//       q: "How soon can I walk after hip replacement?",
//       a: "Most patients stand and take their first steps with a physiotherapist 4–6 hours after surgery. By day 2, patients walk independently with a frame or crutches. By day 4–6, most can manage stairs. Full functional recovery — walking without aids — typically takes 6–8 weeks for the anterior approach and 8–12 weeks for the posterior approach.",
//     },
//     {
//       q: "How long will I need to stay in India?",
//       a: "Most international patients stay 10–14 days in India — 4–6 days in hospital followed by 5–7 days of supervised physiotherapy at a nearby recovery facility before flying home. Economy class travel is safe from day 10–12 with compression stockings and appropriate anticoagulation. PaxGrow arranges serviced accommodation and daily physiotherapy before departure.",
//     },
//     {
//       q: "What is the cost of hip replacement in India vs. the UK or USA?",
//       a: "A complete hip replacement package in India (including implant, surgery, hospital stay, physiotherapy and follow-up) typically costs ₹2.5L–₹5L ($3,000–$6,500), compared to £15,000–£25,000 in the UK and $30,000–$60,000 in the USA — with equivalent implant brands (Zimmer Biomet, Stryker, DePuy Synthes) and superior surgeon experience volumes.",
//     },
//     {
//       q: "Can both hips be replaced at the same time?",
//       a: "Yes. Simultaneous bilateral hip replacement is offered to medically fit patients under 70 at high-volume Indian centres. It reduces total hospitalisation, rehabilitation and travel time. Your surgeon will assess suitability based on cardiac fitness, BMI, bone quality and anaesthesia risk. Many international patients opt for staged bilateral replacement — one hip per visit, 3–6 months apart.",
//     },
//   ],
//   doctors: [
//     {
//       name: "Dr. Rajesh Malhotra",
//       specialty: "Hip Replacement & Robotic Orthopaedics",
//       experience: "30 Years",
//       rating: 4.9,
//       reviews: 3900,
//       image: "https://randomuser.me/api/portraits/men/54.jpg",
//       qualifications: "MBBS, MS (Ortho), DNB, FRCS (Edinburgh)",
//       hospital: "AIIMS, New Delhi",
//     },
//     {
//       name: "Dr. Vijay Bose",
//       specialty: "Hip & Knee Joint Replacement",
//       experience: "28 Years",
//       rating: 4.9,
//       reviews: 3100,
//       image: "https://randomuser.me/api/portraits/men/66.jpg",
//       qualifications: "MBBS, DNB (Ortho), FRCS, Fellowship (USA)",
//       hospital: "Apollo Hospitals, Chennai",
//     },
//     {
//       name: "Dr. Neeraj Adkar",
//       specialty: "Joint Replacement & Sports Orthopaedics",
//       experience: "22 Years",
//       rating: 4.8,
//       reviews: 2400,
//       image: "https://randomuser.me/api/portraits/men/48.jpg",
//       qualifications: "MBBS, MS (Ortho), DNB, FICS, Fellowship (Germany)",
//       hospital: "Kokilaben Dhirubhai Ambani Hospital, Mumbai",
//     },
//   ],
//   testimonials: [
//     {
//       name: "Margaret Achieng",
//       age: 67,
//       location: "Nairobi, Kenya",
//       text: "Severe arthritis had left me wheelchair-bound for two years. The robotic hip replacement at Apollo Chennai changed my life completely. I walked unassisted within a week of surgery and flew home after 12 days. The entire cost — flights, surgery, accommodation, physiotherapy — was still less than the surgery alone would have cost in the UK.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/72.jpg",
//       treatment: "Robotic Total Hip Replacement — Severe Osteoarthritis",
//       date: "January 2024",
//     },
//     {
//       name: "Ibrahim Al-Sayed",
//       age: 54,
//       location: "Kuwait City, Kuwait",
//       text: "Avascular necrosis had destroyed my right hip at a relatively young age. The anterior approach at Medanta meant I had almost no post-operative pain and was walking with one crutch by day two. The anterior approach is simply not available at most hospitals in the Gulf. Worth every moment of the journey.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/61.jpg",
//       treatment: "Anterior Approach Total Hip Replacement — Avascular Necrosis",
//       date: "February 2024",
//     },
//     {
//       name: "Rose Nakamya",
//       age: 71,
//       location: "Kampala, Uganda",
//       text: "My previous hip replacement done abroad had dislocated twice. I needed a complex revision with a constrained liner. PaxGrow found me a revision specialist at Fortis Delhi. The revision was successful and I am now 10 months post-surgery with no further dislocations and full independence.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/65.jpg",
//       treatment: "Revision Total Hip Replacement — Recurrent Dislocation",
//       date: "March 2024",
//     },
//   ],
// };

// const HIP_REPLACEMENT_PAXGROW = {
//   whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//   whyIndiaTitle: "Why African & Gulf Patients Choose India for Hip Replacement",
//   whyIndiaReasons: [
//     "NABH-accredited orthopaedic centres with Mako robotic systems, anterior approach capability and patient-specific implants from Stryker, Zimmer Biomet and DePuy",
//     "Senior orthopaedic surgeons performing 600–1,200 hip replacements per year — far exceeding the volume of most Western surgeons",
//     "Surgery confirmed within 5–7 days of arrival — no 12–18 month NHS waiting lists or insurance pre-authorisation delays",
//     "Apollo, Medanta, AIIMS, Fortis, Kokilaben — globally ranked joint replacement programmes with published outcome data and implant registries",
//   ],
//   conditionsTitle: "Hip Conditions We Facilitate Treatment For",
//   conditions: [
//     "Severe Osteoarthritis of the Hip",
//     "Rheumatoid Arthritis of the Hip",
//     "Avascular Necrosis (AVN) of the Femoral Head",
//     "Post-Traumatic Hip Arthritis",
//     "Hip Fracture — Femoral Neck Fracture",
//     "Failed Previous Hip Replacement",
//     "Hip Dysplasia with Arthritis",
//     "Ankylosing Spondylitis (Hip)",
//     "Paget's Disease of the Hip",
//     "Protrusio Acetabuli",
//     "Psoriatic Arthritis",
//     "Recurrent Hip Dislocation",
//   ],
//   stayValue:
//     "10–14 days total: 4–6 days hospital stay followed by 5–7 days supervised physiotherapy before flying home safely",
//   costTitle: "Why India for Hip Replacement Surgery?",
//   costRows: [
//     {
//       procedure: "Total Hip Replacement (single hip)",
//       india: "₹2.5L–₹4.0L",
//       africa: "$8,000–$15,000",
//       ukusa: "$30,000–$50,000",
//     },
//     {
//       procedure: "Robotic-Assisted Total Hip Replacement",
//       india: "₹3.5L–₹5.5L",
//       africa: "Largely unavailable",
//       ukusa: "$40,000–$65,000",
//     },
//     {
//       procedure: "Bilateral Hip Replacement (both hips)",
//       india: "₹4.5L–₹8.0L",
//       africa: "$14,000–$25,000",
//       ukusa: "$55,000–$90,000",
//     },
//     {
//       procedure: "Hemiarthroplasty (Partial Hip Replacement)",
//       india: "₹1.8L–₹3.0L",
//       africa: "$5,000–$10,000",
//       ukusa: "$20,000–$35,000",
//     },
//     {
//       procedure: "Revision Hip Replacement",
//       india: "₹4.0L–₹7.5L",
//       africa: "Largely unavailable",
//       ukusa: "$55,000–$100,000",
//     },
//   ],
// };

// const HipReplacementPage = () => {
//   return (
//     <TreatmentTemplate
//       treatment={HIP_REPLACEMENT_TREATMENT}
//       paxgrowData={HIP_REPLACEMENT_PAXGROW}
//     />
//   );
// };

// export default HipReplacementPage;


// src/pages/treatments/HipReplacementPage.jsx
import React from "react";
import TreatmentTemplate from "./TreatmentTemplate";
import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

const HIP_REPLACEMENT_TREATMENT = {
  slug: "hip-replacement",
  name: "Hip Replacement Surgery",
  shortName: "Hip Replacement",
  tagline: "Move Freely Again. Precision Surgery. Lasting Relief.",
  heroSubtag:
    "Advanced hip replacement surgery at a fraction of Western costs. India's top orthopaedic surgeons. Outstanding functional outcomes.",
  description:
    "Comprehensive hip replacement care covering total hip replacement, partial (hemiarthroplasty) hip replacement, robotic-assisted surgery, minimally invasive anterior approach and revision hip replacement — supported by advanced physiotherapy, pain management and lifelong post-operative follow-up. Our multidisciplinary orthopaedic teams review every case to deliver globally benchmarked, personalised treatment plans with exceptional outcomes.",
  heroImage: "/HipReplacement.jpeg",
  category: "Orthopedics",
  badge: "Advanced Joint Care",
  accentColor: "blue",
  costCard: {
    label: "Hip replacement packages",
    value: "$3,000–$6,000",
    compare: "vs. $18,000–$30,000 in the UK",
    stay: "Typically 10–14 days in India post-surgery",
    stayCompare: "vs. $30,000–$60,000 in the USA",
  },
  stats: [
    { label: "Success Rate", value: "97%+", icon: Award },
    { label: "Surgeries Performed", value: "25,000+", icon: Users },
    { label: "Years Experience", value: "25+", icon: Shield },
    { label: "Hospital Stay", value: "4–6 Days", icon: Clock },
  ],
  benefits: [
    "Robotic-assisted total hip replacement for millimetre-precise implant positioning",
    "Minimally invasive anterior approach — no muscle cutting, faster recovery",
    "Patient-specific implants manufactured from pre-operative CT scan data",
    "Ceramic, titanium and highly cross-linked polyethylene bearing options",
    "Bilateral (both hips) simultaneous replacement where clinically appropriate",
    "Revision hip replacement for failed previous implants or dislocations",
    "Accelerated rehabilitation protocol — walking within 6 hours of surgery",
    "Comprehensive pain management — multimodal anaesthesia, nerve blocks, epidural",
  ],
  procedure: [
    {
      step: "01",
      title: "Assessment & Planning",
      desc: "Full orthopaedic evaluation — weight-bearing X-rays, MRI, leg length analysis, deformity assessment and 3D implant pre-operative planning.",
      duration: "2–3 Days",
      icon: Calendar,
    },
    {
      step: "02",
      title: "Pre-Operative Optimisation",
      desc: "Cardiac and anaesthesia clearance, physiotherapy assessment, blood optimisation, DVT risk stratification and patient education on recovery.",
      duration: "1–2 Days",
      icon: Activity,
    },
    {
      step: "03",
      title: "Hip Replacement Surgery",
      desc: "Robotic-assisted or conventional total hip replacement via anterior or posterior approach under spinal or general anaesthesia by senior orthopaedic surgeon.",
      duration: "1.5–2.5 Hours",
      icon: ThumbsUp,
    },
    {
      step: "04",
      title: "Rehabilitation & Discharge",
      desc: "Physiotherapy begins 6 hours post-surgery. Walking with frame by day 1. Stair climbing by day 3. Discharge at day 4–6 with home exercise and follow-up protocol.",
      duration: "4–6 Days",
      icon: Heart,
    },
  ],
  faqs: [
    {
      q: "Who needs hip replacement surgery?",
      a: "Hip replacement is recommended for patients with severe hip arthritis (osteoarthritis, rheumatoid arthritis, avascular necrosis or post-traumatic arthritis) causing persistent pain, stiffness, limping and loss of function that has not responded adequately to conservative treatments such as physiotherapy, injections and anti-inflammatory medications.",
    },
    {
      q: "What is the anterior approach to hip replacement?",
      a: "The anterior (front) approach accesses the hip joint without cutting through any major muscles — unlike the traditional posterior approach. This results in less post-operative pain, a lower dislocation risk, faster return to walking and a shorter rehabilitation period. Not all patients are candidates; your surgeon will advise based on your anatomy and BMI.",
    },
    {
      q: "What is robotic-assisted hip replacement?",
      a: "Robotic-assisted hip replacement uses a CT-based 3D model of your hip to plan the exact position, angle and depth of your implant before surgery. During the procedure, the robotic arm guides the surgeon to execute implant placement within 1mm of the pre-operative plan — resulting in better leg length restoration, reduced dislocation risk and faster recovery.",
    },
    {
      q: "How long does a hip replacement last?",
      a: "Modern hip implants last 20–30 years in the majority of patients. Ceramic-on-ceramic and ceramic-on-polyethylene bearing combinations offer the lowest wear rates. Longevity depends on activity level, weight, implant type and surgical technique. Robotic-assisted surgery improves component positioning, one of the most important factors for long-term survival.",
    },
    {
      q: "How soon can I walk after hip replacement?",
      a: "Most patients stand and take their first steps with a physiotherapist 4–6 hours after surgery. By day 2, patients walk independently with a frame or crutches. By day 4–6, most can manage stairs. Full functional recovery — walking without aids — typically takes 6–8 weeks for the anterior approach and 8–12 weeks for the posterior approach.",
    },
    {
      q: "How long will I need to stay in India?",
      a: "Most international patients stay 10–14 days in India — 4–6 days in hospital followed by 5–7 days of supervised physiotherapy at a nearby recovery facility before flying home. Economy class travel is safe from day 10–12 with compression stockings and appropriate anticoagulation. PaxGrow arranges serviced accommodation and daily physiotherapy before departure.",
    },
    {
      q: "What is the cost of hip replacement in India vs. the UK or USA?",
      a: "A complete hip replacement package in India (including implant, surgery, hospital stay, physiotherapy and follow-up) typically costs $3,000–$6,500, compared to $18,000–$30,000 in the UK and $30,000–$60,000 in the USA — with equivalent implant brands (Zimmer Biomet, Stryker, DePuy Synthes) and superior surgeon experience volumes.",
    },
    {
      q: "Can both hips be replaced at the same time?",
      a: "Yes. Simultaneous bilateral hip replacement is offered to medically fit patients under 70 at high-volume Indian centres. It reduces total hospitalisation, rehabilitation and travel time. Your surgeon will assess suitability based on cardiac fitness, BMI, bone quality and anaesthesia risk. Many international patients opt for staged bilateral replacement — one hip per visit, 3–6 months apart.",
    },
  ],
  doctors: [
    {
      name: "Dr. Rajesh Malhotra",
      specialty: "Hip Replacement & Robotic Orthopaedics",
      experience: "30 Years",
      rating: 4.9,
      reviews: 3900,
      image: "https://randomuser.me/api/portraits/men/54.jpg",
      qualifications: "MBBS, MS (Ortho), DNB, FRCS (Edinburgh)",
      hospital: "AIIMS, New Delhi",
    },
    {
      name: "Dr. Vijay Bose",
      specialty: "Hip & Knee Joint Replacement",
      experience: "28 Years",
      rating: 4.9,
      reviews: 3100,
      image: "https://randomuser.me/api/portraits/men/66.jpg",
      qualifications: "MBBS, DNB (Ortho), FRCS, Fellowship (USA)",
      hospital: "Apollo Hospitals, Chennai",
    },
    {
      name: "Dr. Neeraj Adkar",
      specialty: "Joint Replacement & Sports Orthopaedics",
      experience: "22 Years",
      rating: 4.8,
      reviews: 2400,
      image: "https://randomuser.me/api/portraits/men/48.jpg",
      qualifications: "MBBS, MS (Ortho), DNB, FICS, Fellowship (Germany)",
      hospital: "Kokilaben Dhirubhai Ambani Hospital, Mumbai",
    },
  ],
  testimonials: [
    {
      name: "Margaret Achieng",
      age: 67,
      location: "Nairobi, Kenya",
      text: "Severe arthritis had left me wheelchair-bound for two years. The robotic hip replacement at Apollo Chennai changed my life completely. I walked unassisted within a week of surgery and flew home after 12 days. The entire cost — flights, surgery, accommodation, physiotherapy — was still less than the surgery alone would have cost in the UK.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/72.jpg",
      treatment: "Robotic Total Hip Replacement — Severe Osteoarthritis",
      date: "January 2024",
    },
    {
      name: "Ibrahim Al-Sayed",
      age: 54,
      location: "Kuwait City, Kuwait",
      text: "Avascular necrosis had destroyed my right hip at a relatively young age. The anterior approach at Medanta meant I had almost no post-operative pain and was walking with one crutch by day two. The anterior approach is simply not available at most hospitals in the Gulf. Worth every moment of the journey.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/61.jpg",
      treatment: "Anterior Approach Total Hip Replacement — Avascular Necrosis",
      date: "February 2024",
    },
    {
      name: "Rose Nakamya",
      age: 71,
      location: "Kampala, Uganda",
      text: "My previous hip replacement done abroad had dislocated twice. I needed a complex revision with a constrained liner. PaxGrow found me a revision specialist at Fortis Delhi. The revision was successful and I am now 10 months post-surgery with no further dislocations and full independence.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/65.jpg",
      treatment: "Revision Total Hip Replacement — Recurrent Dislocation",
      date: "March 2024",
    },
  ],
};

const HIP_REPLACEMENT_PAXGROW = {
  whyIndiaSubtitle: "WHY PAXGROW + INDIA",
  whyIndiaTitle: "Why African & Gulf Patients Choose India for Hip Replacement",
  whyIndiaReasons: [
    "NABH-accredited orthopaedic centres with Mako robotic systems, anterior approach capability and patient-specific implants from Stryker, Zimmer Biomet and DePuy",
    "Senior orthopaedic surgeons performing 600–1,200 hip replacements per year — far exceeding the volume of most Western surgeons",
    "Surgery confirmed within 5–7 days of arrival — no 12–18 month NHS waiting lists or insurance pre-authorisation delays",
    "Apollo, Medanta, AIIMS, Fortis, Kokilaben — globally ranked joint replacement programmes with published outcome data and implant registries",
  ],
  conditionsTitle: "Hip Conditions We Facilitate Treatment For",
  conditions: [
    "Severe Osteoarthritis of the Hip",
    "Rheumatoid Arthritis of the Hip",
    "Avascular Necrosis (AVN) of the Femoral Head",
    "Post-Traumatic Hip Arthritis",
    "Hip Fracture — Femoral Neck Fracture",
    "Failed Previous Hip Replacement",
    "Hip Dysplasia with Arthritis",
    "Ankylosing Spondylitis (Hip)",
    "Paget's Disease of the Hip",
    "Protrusio Acetabuli",
    "Psoriatic Arthritis",
    "Recurrent Hip Dislocation",
  ],
  stayValue:
    "10–14 days total: 4–6 days hospital stay followed by 5–7 days supervised physiotherapy before flying home safely",
  costTitle: "Why India for Hip Replacement Surgery?",
  costRows: [
    {
      procedure: "Total Hip Replacement (single hip)",
      india: "$3,000–$4,800",
      africa: "$8,000–$15,000",
      ukusa: "$30,000–$50,000",
    },
    {
      procedure: "Robotic-Assisted Total Hip Replacement",
      india: "$4,200–$6,600",
      africa: "Largely unavailable",
      ukusa: "$40,000–$65,000",
    },
    {
      procedure: "Bilateral Hip Replacement (both hips)",
      india: "$5,400–$9,600",
      africa: "$14,000–$25,000",
      ukusa: "$55,000–$90,000",
    },
    {
      procedure: "Hemiarthroplasty (Partial Hip Replacement)",
      india: "$2,200–$3,600",
      africa: "$5,000–$10,000",
      ukusa: "$20,000–$35,000",
    },
    {
      procedure: "Revision Hip Replacement",
      india: "$4,800–$9,000",
      africa: "Largely unavailable",
      ukusa: "$55,000–$100,000",
    },
  ],
};

const HipReplacementPage = () => {
  return (
    <TreatmentTemplate
      treatment={HIP_REPLACEMENT_TREATMENT}
      paxgrowData={HIP_REPLACEMENT_PAXGROW}
    />
  );
};

export default HipReplacementPage;